import { Injectable } from '@angular/core';
import { EmailQueryInterface } from '@zaoblako/shared/common/dtos/email-query.dto';
import { ProfileChangePasswordInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-change-password.dto';
import type { ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';
import type { ProfileFlatListQueryInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-flat-list-query.dto';
import type { ProfileListPageInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-list-page.dto';
import { ProfileLoginFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-login-find.dto';
import { ProfileLoginFormInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-login-form.dto';
import type { ProfilePageListQueryInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-page-list-query.dto';
import type { ProfileTestEmailFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-test-email-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends BaseService {
  protected baseUrl = '/basis/security/profile';

  public check(): Observable<ProfileLoginFindInterface> {
    return this.http.get<ProfileLoginFindInterface>(`${this.baseUrl}/check`);
  }

  public login(login: ProfileLoginFormInterface): Observable<ProfileLoginFindInterface> {
    return this.http.post<ProfileLoginFindInterface>(`${this.baseUrl}/login`, login);
  }

  public changePassword(id: number, body: ProfileChangePasswordInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/change-password`, body);
  }

  public findManyFlat(params?: ProfileFlatListQueryInterface): Observable<ProfileFindInterface[]> {
    return this.http.get<ProfileFindInterface[]>(`${this.baseUrl}/flat`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public findManyPage(params?: ProfilePageListQueryInterface): Observable<ProfileListPageInterface> {
    return this.http.get<ProfileListPageInterface>(`${this.baseUrl}/page`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public testEmail(email: EmailQueryInterface): Observable<ProfileTestEmailFindInterface> {
    return this.http.get<ProfileTestEmailFindInterface>(`${this.baseUrl}/test-email`, {
      params: this.objectToHttpParams(email)
    });
  }

  public resetPassword(email: EmailQueryInterface): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/reset-password`, email);
  }

  public leaveTelegramChat(id: number): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${id}/leave-telegram-chat`);
  }
}
